export default {
  setTagList(state, { tagList }) {
    state.tagList = tagList;
  },
  setEngagementTypeId(state, { engagementTypeId }) {
    state.engagementTypeId = engagementTypeId;
  },
  setTimezone(state, { timezone }) {
    state.timezone = timezone;
  },
  setEngagement(state, { engagement }) {
    state.engagement = engagement;
  },
  setEngagementParameters(state, { engagementParameters }) {
    state.engagementParameters = engagementParameters;
  },
  setTagArray(state, { tagArray }) {
    state.tagArray = tagArray;
  },
  setIsRfmEnabled(state, { isRfmEnabled }) {
    state.isRfmEnabled = isRfmEnabled;
  },
  setCustomerCustomList(state, { customerCustomList }) {
    state.customerCustomList = customerCustomList;
  },
  setIsDev(state, { isDev }) {
    state.isDev = isDev;
  },
  setIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },
  setCountTotalCustomers(state, { countTotalCustomers }) {
    state.countTotalCustomers = countTotalCustomers;
  },
  setCountAudienceCustomers(state, { countAudienceCustomers }) {
    state.countAudienceCustomers = countAudienceCustomers;
  },
  setCustomAudienceBrowserLangaugeList(state, { customAudienceBrowserLangaugeList }) {
    state.customAudienceBrowserLangaugeList = customAudienceBrowserLangaugeList;
  },
  setCustomAudienceCityList(state, { customAudienceCityList }) {
    state.customAudienceCityList = customAudienceCityList;
  },
  setCustomAudienceCountryList(state, { customAudienceCountryList }) {
    state.customAudienceCountryList = customAudienceCountryList;
  },
  setCustomAudienceFirstNameList(state, { customAudienceFirstNameList }) {
    state.customAudienceFirstNameList = customAudienceFirstNameList;
  },
  setCustomFieldsAudience(state, { customFieldsAudience }) {
    state.customFieldsAudience = customFieldsAudience;
  },
  setCancelToken(state, { cancelToken }) {
    state.cancelToken = cancelToken;
  },
};
